/**
 * Table Configuration Interfaces
 * Framework-agnostic table/grid definitions
 */

export type ColumnType =
  | "text"
  | "number"
  | "date"
  | "datetime"
  | "boolean"
  | "badge"
  | "link"
  | "image"
  | "action"
  | "custom";

export type ColumnAlignment = "left" | "center" | "right";

export type SortDirection = "asc" | "desc" | null;

export interface TableColumn<T = any> {
  key: string;
  label: string;
  type?: ColumnType;
  sortable?: boolean;
  filterable?: boolean;
  searchable?: boolean;
  width?: string;
  minWidth?: string;
  maxWidth?: string;
  alignment?: ColumnAlignment;
  hidden?: boolean;
  sticky?: boolean;
  render?: (value: any, row: T) => string;
  format?: (value: any) => string;
  className?: string;
}

export interface TableAction<T = any> {
  icon?: string;
  label: string;
  className?: string;
  tooltip?: string;
  visible?: (row: T) => boolean;
  disabled?: (row: T) => boolean;
  onClick: (row: T) => void;
}

export interface TableConfig<T = any> {
  columns: TableColumn<T>[];
  actions?: TableAction<T>[];
  pagination?: boolean;
  pageSize?: number;
  pageSizeOptions?: number[];
  sortable?: boolean;
  filterable?: boolean;
  searchable?: boolean;
  selectable?: boolean;
  multiSelect?: boolean;
  exportable?: boolean;
  className?: string;
}

export interface TableSort {
  column: string;
  direction: SortDirection;
}

export interface TableFilter {
  column: string;
  value: any;
  operator?:
    | "equals"
    | "contains"
    | "startsWith"
    | "endsWith"
    | "gt"
    | "lt"
    | "gte"
    | "lte";
}

export interface TablePagination {
  page: number;
  pageSize: number;
  total: number;
}
